import React, { useContext } from 'react'
import { Text, View } from 'oio-react'
import { Link } from 'react-router-dom'
import { initiativeUrl } from 'config/constants/urls'
import ContainerBlock from 'src/apps/CustomApp/blocks/Container'
import LayoutContainer from 'src/apps/CustomApp/components/LayoutContainer'
import Title from 'src/apps/CustomApp/components/Title'
import Titlebar from 'src/apps/CustomApp/components/Titlebar'
import { useInitiativeList, useMe } from 'src/graphql/hooks'
import ProtoThemeContext from 'src/libraries/contexts/ProtoTheme'

const Bookmarks = () => {
   const { protoTheme: theme } = useContext(ProtoThemeContext)
   const { isLoggedIn } = useMe()

   const { initiativeList } = useInitiativeList({
      archived: 'exclude',
      sortBy: 'name',
      userRelationshipFilter: {
         userId: 'me',
         hasElementType: 'favorited'
      }
   }, {
      skip: !isLoggedIn
   })

   if (!isLoggedIn) {
      return null
   }

   return (
      <LayoutContainer>
         <ContainerBlock>
            <Titlebar>
               <Title color={theme.tmpContentTitleColor}>
                  Bookmarks
               </Title>
            </Titlebar>
            <View>
               {initiativeList.items.map(initiative => (
                  <Link key={initiative.id} to={initiativeUrl(initiative)}>
                     <View
                        display="flex"
                        alignItems="center"
                        height={theme.tmpPrimaryButtonHeight}
                        borderBottom={`1px solid ${theme.tmpContentLineColor}`}>
                        <Text size={theme.tmpBodyTextSize} color={theme.tmpButtonTextColor}>
                           {initiative.name}
                        </Text>
                     </View>
                  </Link>
               ))}
            </View>
         </ContainerBlock>
      </LayoutContainer>
   )
}

export default Bookmarks
